import { render, staticRenderFns } from "./ib-paginate.vue?vue&type=template&id=554e8e18&lang=pug&"
import script from "./ib-paginate.vue?vue&type=script&lang=js&"
export * from "./ib-paginate.vue?vue&type=script&lang=js&"
import style0 from "./ib-paginate.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('554e8e18')) {
      api.createRecord('554e8e18', component.options)
    } else {
      api.reload('554e8e18', component.options)
    }
    module.hot.accept("./ib-paginate.vue?vue&type=template&id=554e8e18&lang=pug&", function () {
      api.rerender('554e8e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/ib-paginate.vue"
export default component.exports